<template>
  <div
    class="d-flex justify-content-center overflow-hidden position-relative flex-fill mb-lg-2 pl-2"
    :class="[emptyRoomList ? 'align-items-center' : 'align-items-start']"
    style="margin-bottom: 25px; margin-right: -16px;"
  >
    <div
      v-if="emptyRoomList"
      class="text-center"
    >
      <span v-if="loading">{{ $t('rooms.loading') }}</span>
      <span v-else-if="emptyRoomList">{{ $t('rooms.empty') }}</span>
    </div>
    <virtual-list
      v-else
      ref="vsl"
      class="virtual-list list-unstyled chat-list"
      style="overflow-y: scroll; width: 100%; height: 100%"

      :root-tag="'ul'"
      :data-key="'id'"
      :data-sources="roomList"
      :data-component="roomOne"

      @tobottom="onToBottom"
      @scroll="onScroll"
    >
      <div
        slot="footer"
        class="footer"
      >
        <div
          v-show="loading"
          class="text-center text-muted p-2 mb-4"
        >
          {{ $t('home.loading') }}
        </div>
      </div>
    </virtual-list>
    <widget-loader v-if="loadingVirtualList" />
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import VirtualList from 'vue-virtual-scroll-list';
import roomOne from "./OneRoomsComponents";
import WidgetLoader from "../../Widget/WidgetLoader";

export default {
  name: 'RoomsList',
  components: {
    WidgetLoader,
    VirtualList,
  },
  data() {
    return {
      roomOne,

      loadingVirtualList: false,
      scrollBottomFinished: false,
      page: 1,
      page_size: 20,
    }
  },
  computed: {
    ...mapState('rooms', [
      'loading',
      'fetchFilter',
      'listSearch',
      'listBase',
    ]),
    ...mapGetters('rooms', [
      'searchMod',
      'listBaseOrder',
    ]),
    roomList() {
      if (this.searchMod) {
        return this.listSearch || [];
      }

      return this.listBaseOrder || [];
    },
    emptyRoomList() {
      return this.roomList.length === 0
    },
  },
  watch: {
    fetchFilter: {
      deep: true,
      handler() {
        this.onUpdateFetchFilter();
      },
    },
  },
  mounted() {
    this.onUpdateFetchFilter();
  },
  methods: {
    onUpdateFetchFilter() {
      this.$refs.vsl?.scrollToOffset(0);
      this.page = 1;
      this.loadingVirtualList = true;
      this.fetch({reset: true}).finally(() => this.loadingVirtualList = false);
    },
    fetch(options = {}) {
      return this.$store
        .dispatch('rooms/list', {page: this.page, page_size: this.page_size, ...options})
        .then(body => this.scrollBottomFinished = Boolean(body.length) === false)
    },
    onScroll() {
      if (this.loading || this.scrollBottomFinished) return;

      //console.info('ListMessageChatComponent | onScroll');

      const {vsl} = this.$refs;
      const is = ((vsl.getScrollSize() - vsl.getOffset()) - vsl.getClientSize()) < 50;
      is && this.onToBottom();
    },
    onToBottom() {
      if (this.loading || this.scrollBottomFinished) return;

      //console.info('ListMessageChatComponent | onToBottom');

      this.page += 1;
      this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.VueCarousel-slide > div {
  padding-left: 5px;
  padding-right: 5px;
}
</style>






